var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tenancyDepositRelease"},[_c('h2',[_vm._v(_vm._s(_vm.defaultHeader))]),_c('InfoCard',{staticClass:"mt-5"},[_vm._v(" Hvis leietaker ikke besvarer avslutningen innen 30 dager så må avslutningen startes på nytt ")]),_c('BlockContainer',{staticClass:"p-5 mt-4"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }